import {UI_READINESS_POLICY} from './ui-readiness-contract'

export type UiReadinessOrigin = typeof UI_READINESS_POLICY & {readonly origin_request_id: string}

function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

export function parseUiReadinessOrigin(value: unknown): UiReadinessOrigin | undefined {
  if (
    !isRecord(value) ||
    value.schema_version !== 1 ||
    typeof value.origin_request_id !== 'string' ||
    !/^[\x20-\x7e]{1,128}$/.test(value.origin_request_id)
  ) {
    return undefined
  }
  const policies = [
    {value: value.client_readiness, version: UI_READINESS_POLICY.policy_version},
    {value: value.ui_readiness, version: 'ui_readiness_v1'},
  ].filter(policy => policy.value !== undefined)
  if (policies.length === 0) return undefined
  for (const {value: policy, version} of policies) {
    if (!isRecord(policy) || policy.policy_version !== version) return undefined
    for (const key of ['gate_policy', 'required_obligations'] as const) {
      if (policy[key] !== UI_READINESS_POLICY[key]) return undefined
    }
  }
  return {...UI_READINESS_POLICY, origin_request_id: value.origin_request_id}
}

const COPILOT_ROUTE_KEYS = [
  'copilotAgentsRoute',
  'copilotAgentsConversationRoute',
  'copilotAgentsNewChatRoute',
  'copilotAgentsChatRoute',
  'copilotAgentsTaskRoute',
  'repoAgentsRoute',
  'repoTaskByIdRoute',
] as const

export function readUiReadinessOrigin(embeddedData: unknown): UiReadinessOrigin | undefined {
  if (!isRecord(embeddedData)) return undefined
  const candidates: unknown[] = []
  if (isRecord(embeddedData.appPayload) && embeddedData.appPayload.copilotTelemetryContext !== undefined) {
    candidates.push(embeddedData.appPayload.copilotTelemetryContext)
  }
  if (isRecord(embeddedData.payload)) {
    for (const key of COPILOT_ROUTE_KEYS) {
      const route = embeddedData.payload[key]
      if (isRecord(route) && route.copilotTelemetryContext !== undefined) candidates.push(route.copilotTelemetryContext)
    }
  }
  let origin: UiReadinessOrigin | undefined
  for (const candidate of candidates) {
    const parsed = parseUiReadinessOrigin(candidate)
    if (!parsed || (origin && origin.origin_request_id !== parsed.origin_request_id)) return undefined
    origin = parsed
  }
  return origin
}
